import request from "@/utils/request";

//添加团体
export const addGroup = data => {
	return request({
		url: "/usergroup",
		method: "POST",
		data,
	});
};
//获取团体列表
export const getGroupList = params => {
	return request({
		url: "/usergroup",
		method: "GET",
		params,
	});
};
//获取团体成员列表

export const getMemberList = params => {
	return request({
		url: "/nfccard",
		method: "GET",
		params,
	});
};

//删除团体列表
export const deleteGroupList = params => {
	return request({
		url: "/usergroup",
		method: "DELETE",
		params,
	});
};
// 查询成员信息

// export const getUserList = params => {
// 	return request({
// 		url: "/wechatuser",
// 		method: "GET",
// 		params,
// 	});
// };
// 添加成员

export const addMemeber = data => {
	return request({
		url: "/nfccard",
		method: "POST",
		data,
	});
};

// 设置资费

export const setRate = data => {
	return request({
		url: "/feepolicy",
		method: "POST", 
    data,
	});
};
// 充值

export const recharge = data => {
	return request({
		url: "/usergroup/charge",   
    method: "POST",
    data,
	});
};
export const getChargeHistory = params => {
	return request({
		url: "/usergroup/charge/history",
		method: "GET",
		params,
	});
};

// 车队密码校验

export const setFleetPws = data => {
	return request({
		url: "/usergroup/securitykey",   
		method: "POST",
		data,
	});
};